var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0835 12.7497H10.9168V14.583H9.0835V12.7497ZM9.0835 5.41634H10.9168V10.9163H9.0835V5.41634ZM9.991 0.833008C4.931 0.833008 0.833496 4.93967 0.833496 9.99967C0.833496 15.0597 4.931 19.1663 9.991 19.1663C15.0602 19.1663 19.1668 15.0597 19.1668 9.99967C19.1668 4.93967 15.0602 0.833008 9.991 0.833008ZM10.0002 17.333C5.9485 17.333 2.66683 14.0513 2.66683 9.99967C2.66683 5.94801 5.9485 2.66634 10.0002 2.66634C14.0518 2.66634 17.3335 5.94801 17.3335 9.99967C17.3335 14.0513 14.0518 17.333 10.0002 17.333Z",
    fill: "#FA4D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadError);
export default __webpack_public_path__ + "static/media/load-error.425a2061a58fafe136e9a19e071dbf1d.svg";
export { ForwardRef as ReactComponent };